import { clsx } from 'clsx'

interface IntegrationBadgeProps {
  platform: string
  size?: 'sm' | 'md'
  showLabel?: boolean
}

const platformConfig: Record<string, { color: string; bgColor: string; label: string }> = {
  square: {
    color: 'text-black',
    bgColor: 'bg-white border border-gray-200',
    label: 'Square',
  },
  doordash: {
    color: 'text-red-700',
    bgColor: 'bg-red-50',
    label: 'DoorDash',
  },
  ubereats: {
    color: 'text-green-700',
    bgColor: 'bg-green-50',
    label: 'Uber Eats',
  },
  grubhub: {
    color: 'text-orange-700',
    bgColor: 'bg-orange-50',
    label: 'Grubhub',
  },
  bank: {
    color: 'text-blue-700',
    bgColor: 'bg-blue-50',
    label: 'Bank',
  },
}

export default function IntegrationBadge({ platform, size = 'sm', showLabel = true }: IntegrationBadgeProps) {
  const config = platformConfig[platform.toLowerCase()] || {
    color: 'text-gray-700',
    bgColor: 'bg-gray-100',
    label: platform,
  }

  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium rounded-full',
        config.color,
        config.bgColor,
        {
          'px-2 py-0.5 text-xs': size === 'sm',
          'px-3 py-1 text-sm': size === 'md',
        }
      )}
    >
      {platform.toLowerCase() === 'square' && <SquareIcon className="w-3 h-3 mr-1" />}
      {platform.toLowerCase() === 'doordash' && <DoorDashIcon className="w-3 h-3 mr-1" />}
      {platform.toLowerCase() === 'ubereats' && <UberEatsIcon className="w-3 h-3 mr-1" />}
      {platform.toLowerCase() === 'grubhub' && <GrubhubIcon className="w-3 h-3 mr-1" />}
      {showLabel && config.label}
    </span>
  )
}

function SquareIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <rect x="3" y="3" width="18" height="18" rx="3" />
    </svg>
  )
}

function DoorDashIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <circle cx="12" cy="12" r="10" />
    </svg>
  )
}

function UberEatsIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
    </svg>
  )
}

function GrubhubIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </svg>
  )
}
